import { QRCodeSVG } from "qrcode.react";

export const TicketQR = ({ code, size = 150, className = "" }) => (
  <div data-testid="ticket-qr" className={`inline-block rounded-2xl bg-white p-3 ${className}`}>
    <QRCodeSVG value={code} size={size} level="M" />
  </div>
);
